import mixin from './mixin'
import { getSession } from '@/common/js/api'
import addxin from './components/adder-mixin'
import { replaceConditions } from '@/common/js/assist'
import { findCheck, getNameOfData, getKeyOfData, clearTagOfData, isArray, trim, timeout, applyKey } from '@/common/js/utils'
import { android_version, ios_version } from '@/data/baidu/ad_target_data.js'
import cityData from '@/data/baidu/city_province'
import newInterestData from '@/data/baidu/new_interests'
import gategoryData from '@/data/baidu/app_categroy'
import articleData from '@/data/baidu/article_categroy'
import themeData from '@/data/baidu/theme_categroy'
import mediagoryData from '@/data/baidu/media_categroy'
// 引用组件
import Selecter from '@/components/select/selecter.vue'
import Landpage from '@/components/landpage/landpage.vue'
import Butler from '@/components/butler/manager.vue'
import Adder from './components/add/adder.vue'
import Retarget from './components/retarget/retarget.vue'
import Convert from './components/convert/converter.vue'
import Resulter from './components/convert/resulter.vue'
import RangeAge from '@/components/range/baidu-age.vue'
import KeywordInterest from '@/views/create/baidu_local/components/keywordinterest/'

// model
import { getCaoHuaGames, getCaoHuaAgent } from '@/api/common.model'
import {
  getCampaign,
  getTagFilterFeed,
  getConvert,
  addAdgroup,
  getAdgroup,
  updateAdgroup,
  beCreative,
  creatAdgroup,
  getAudience
} from '@/api/baidu.model'
export default {
  name: 'plan',
  mixins: [mixin, addxin],
  components: { Selecter, Landpage, Butler, Adder, Retarget, Convert, Resulter, RangeAge, KeywordInterest },
  computed: {
    editState() {
      return this.$router.currentRoute.query.t === 'edit'
    },
    isAndroid() {
      return this.plan.ch_platform_id === 1
    },
    platformGameData() {
      return this.gameData.filter((ret) => ret.ch_platform_id === this.plan.ch_platform_id)
    },
    useCrowd() {
      return this.audienceData.some((ret) => ret.select === 'include')
    },
    disCrowd() {
      const isUseWord = this.keywordsType === 'ADD'
      const isUseIntrest = this.interestType === 'CUSTOM'
      return isUseWord || isUseIntrest
    },
    disabledptype() {
      return (this.ftypes === 'TYPE' || isArray(this.plan.ftypes)) && (this.plan.ftypes.includes(4) || this.plan.ftypes.includes(8))
    },
    bindMediaType() {
      return this.disabledptype && this.plan.ftypes.length === 1 && this.audienceMode === 'NONE'
    },
    bindTiebaType() {
      return isArray(this.plan.ftypes) && this.plan.ftypes.includes(2) && this.plan.ftypes.length === 1 && this.audienceMode === 'NONE'
    },
    bindBaiduType() {
      const baidu = isArray(this.plan.ftypes) && this.plan.ftypes.includes(1) && this.plan.ftypes.length === 1
      const producttypes = this.plan.producttypes === 0 || (isArray(this.plan.producttypes) && this.plan.producttypes.includes(2))
      return baidu && producttypes
    },
    bindFtypes() {
      return isArray(this.plan.ftypes) && this.plan.ftypes.includes(262144)
    },
    mult_city() {
      return findCheck(this.cityData)
    },
    mult_interest() {
      return findCheck(this.interestData)
    },
    mult_audience() {
      return findCheck(this.audienceData)
    },
    mult_gategory() {
      return findCheck(this.gategoryData)
    },
    mult_theme() {
      return findCheck(this.themeData)
    },
    mult_article() {
      return findCheck(this.articleData)
    },
    mult_mediagory() {
      return findCheck(this.mediagoryData)
    },
    isLink() {
      return this.plan.landing_type === 'LINK'
    }
  },
  watch: {
    isAndroid(val) {
      this.$set(this.plan, 'callback_switch', !val ? 1 : 0)
      this.$set(this.plan, 'callback_settings', ['callbackTypeActive', 'callbackTypeRegist', 'callbackTypeRecharge', 'callbackTypeMoney'])
    },
    'plan.campaignFeedName'(nVal) {
      if (nVal && !this.editState) {
        nVal = trim(nVal)
        nVal = nVal.replace(/(_[0-9]+|_[0-9]+_[0-9]+)$/, '')
        this.plan.plan_name = nVal
      }
    },
    'plan.subject'(nVal) {
      if (nVal > 1) {
        this.plan.landing_type = 'APP'
        this.plan.ch_platform_id = nVal === 2 ? 2 : 1
        this.plan.device = nVal === 2 ? '1' : '2'
      } else {
        this.plan.landing_type = 'LINK'
        this.plan.ch_platform_id = 1
        this.plan.device = '2'
      }
    },
    'plan.ch_platform_id'(nVal) {
      nVal === 2 && (this.appType = 'all')
      this.plan.device = nVal === 1 ? '2' : '1'
    },
    'plan.bidtype'(nVal) {
      if (nVal === 2) {
        this.ad = 'CPM'
        this.plan.innerUrl = true
      } else if (nVal === 1) {
        this.ad = 'CPC'
        this.plan.innerUrl = true
      } else this.ad = 'oCPC'
      this.changeBidtype(nVal, this.bindMediaType)
    },
    audienceData: {
      handler(nVal) {
        if (nVal && nVal.length) {
          const includes = nVal.filter((ret) => ret.select === 'include').map((t) => t.id)
          const excludes = nVal.filter((ret) => ret.select === 'exclude').map((t) => t.id)
          if (includes.length) this.plan.crowd = includes
          else this.plan.crowd = ''
          if (excludes.length) this.plan.excludeCrowd = excludes
          else this.plan.excludeCrowd = ''
        }
      },
      deep: true
    },

    disabledptype(nVal) {
      if (nVal) this.plan.producttypes = 0
    },
    bindMediaType(nVal) {
      if (!nVal) {
        this.plan.mediaCategoriesBindType = '0'
        this.radioChange('mediagoryData')
      }
      this.changeBidtype(this.plan.bidtype, nVal)
    },
    bindTiebaType(nVal) {
      if (!nVal) {
        this.directoriesType = 'NONE'
        this.radioChange('themeData')
      }
    },
    bindBaiduType(nVal) {
      if (!nVal) {
        this.article = 'NONE'
        this.radioChange('articleData')
      }
    },
    bindFtypes(nVal) {
      if (nVal) this.plan.leagueOpenFlag = 1
    },
    audienceMode(nVal) {
      if (nVal === 'NONE') {
        this.audienceData.forEach((ret) => {
          this.$set(ret, 'check', false)
        })
      } else {
        // this.interestType = 'NONE'
        // this.keywordsType = 'NONE'
        this.directoriesType = 'NONE'
      }
    },
    keywordsType(nVal) {
      // 不限清空数据
      if (nVal === 'NONE') {
        this.clearWordData()
      } else if (nVal === 'CUSTOM') this.clearWordData()
    },
    appType(nVal) {
      if (nVal === 'all') {
        this.radioChange('gategoryData')
        this.clearAppData()
      } else if (nVal === 'custom') this.radioChange('gategoryData')
      else this.clearAppData()
    },
    managePlan(nVal) {
      if (isArray(nVal) && nVal.length) {
        this.plan.monitor_template_id = nVal[0].id
      } else {
        this.plan.monitor_template_id = undefined
      }
    },
    mult_mediagory(nVal) {
      if (nVal && nVal.length) {
        this.plan.mediaCategories = nVal.map((ret) => ret.id).join(',')
      } else {
        this.plan.mediaCategories = '0'
      }
    },
    mult_city(nVal) {
      if (nVal && nVal.length) {
        this.plan.region = nVal.map((ret) => ret.id).join(',')
      } else {
        this.plan.region = '9999999'
      }
    },
    mult_interest(nVal) {
      if (nVal && nVal.length) {
        this.plan.newInterests = nVal.map((ret) => ret.id).join(',')
      } else {
        this.plan.newInterests = '0'
      }
    },
    mult_audience(nVal) {
      if (nVal && nVal.length) {
        this.plan.audience = nVal.map((ret) => ret.id)
      } else {
        this.plan.audience = undefined
      }
    },
    mult_theme(nVal) {
      if (nVal && nVal.length) {
        this.plan.directories = nVal.map((ret) => ret.id).join(',')
      } else {
        this.plan.directories = '0'
      }
    },
    mult_article(nVal) {
      if (nVal && nVal.length) {
        this.plan.articleType = nVal.map((ret) => ret.id).join(',')
      } else {
        this.plan.articleType = '0'
      }
    },
    mult_gategory(nVal) {
      let val = []
      if (this.appType === 'category') {
        if (nVal && nVal.length) {
          val = nVal.map((ret) => {
            return { id: ret.id }
          })
        }
        this.$set(this.plan, 'app', val)
      }
    },
    mult_app(nVal) {
      let val = []
      if (this.appType === 'custom') {
        if (nVal && nVal.length) {
          val = nVal.map((ret) => {
            return { id: ret.id, name: ret.name } // [name] 新增/修改不用传
          })
        }
        this.$set(this.plan, 'app', val)
      }
    }
  },
  methods: {
    getData() {
      const { ad_account_id, ad_id } = this.plan
      if (ad_account_id && ad_id) {
        Promise.all([getAdgroup({ ad_account_id, ad_id }), beCreative({ ad_account_id, ad_id })])
          .then((data) => {
            const [adGroupData, hasCreative] = data
            if (typeof hasCreative === 'boolean') this.creativStat = Boolean(hasCreative)
            // 推广单元详情
            if (adGroupData) {
              const { plan_info, out_plan_info } = adGroupData
              const games = this.gameData.filter((ret) => ret.id === plan_info.game_id).pop()

              plan_info.ad_id = parseInt(plan_info.ad_id)
              plan_info.package = games && games.ad_package
              // 代投
              plan_info.agent = plan_info.proxy_account_id ? 'AGENT' : 'NOAGENT'
              // 计划管家 暂时不支持
              if (plan_info.monitor_template_id) {
                this.managePlan = [
                  {
                    id: plan_info.monitor_template_id,
                    ruleName: plan_info.monitor_template_name
                  }
                ]
              }
              // 是否使用内部落地页的返显
              !this.editState && (this.plan.innerUrl = plan_info.use_innerPage)
              this.plan = Object.assign(this.plan, plan_info, {
                callback_switch: plan_info.callbackSwitch,
                callback_settings: plan_info.callbackSettings
              })

              if (isArray(out_plan_info) && out_plan_info.length) {
                const { ftypes, producttypes, leagueOpenFlag, bidtype, paused, audience, ocpc } = out_plan_info[0]
                let {
                  age,
                  customAge,
                  region,
                  sex,
                  education,
                  newInterests,
                  keywords,
                  keywordsExtend,
                  directories,
                  articleType,
                  excludeCrowd,
                  crowd,
                  device,
                  net,
                  app,
                  androidVersion,
                  iosVersion,
                  lifeStage,
                  autoExpansion,
                  excludeTrans,
                  mediaCategoriesBindType,
                  mediaCategories
                } = audience

                this.plan = Object.assign(this.plan, {
                  paused,
                  bidtype,
                  sex,
                  net,
                  device,
                  keywordsExtend,
                  mediaCategoriesBindType,
                  autoExpansion,
                  excludeTrans
                })

                if (bidtype === 3 && ocpc) {
                  const {
                    appTransId,
                    ocpcBid,
                    lpUrl,
                    transFrom,
                    transType,
                    transTypeAttribute,
                    optimizeDeepTrans,
                    deepTransType,
                    deepOcpcBid,
                    useRoi,
                    roiRatio
                  } = ocpc

                  let deep_bid_mode = true
                  let deep_mode_type = ''
                  if (optimizeDeepTrans) deep_mode_type = 'optimizeDeepTrans'
                  else if (useRoi) deep_mode_type = 'useRoi'
                  else deep_bid_mode = false
                  this.plan = Object.assign(this.plan, {
                    appTransId,
                    ocpcBid,
                    lpUrl,
                    transFrom,
                    transType,
                    deepTransType,
                    deepOcpcBid,
                    roiRatio,
                    deep_bid_mode,
                    deep_mode_type
                  })

                  // 20221129更改：转化类型为付费时，增加优化付费次数勾选，单条修改时默认禁用，不可更改
                  if (transTypeAttribute === 2) {
                    this.plan.transTypeAttribute = true
                  }
                }
                // 流量版位
                if (isArray(ftypes) && !ftypes.length) {
                  this.plan.ftypes = 0
                  this.ftypes = 'NONE'
                } else if (isArray(ftypes)) {
                  this.ftypes = ftypes.includes(4) ? 'TYPE' : 'NAME'
                  this.plan.ftypes = ftypes
                  if (typeof leagueOpenFlag === 'number') this.plan.leagueOpenFlag = leagueOpenFlag
                }
                if (isArray(producttypes) && !producttypes.length) this.plan.producttypes = 0
                else if (isArray(producttypes)) this.plan.producttypes = producttypes
                // 年龄绑定
                age = applyKey(age)
                customAge = applyKey(customAge)
                education = applyKey(education)
                this.ageMode = 'NONE'
                if (age && age !== '0') {
                  this.ageMode = 'RANGE'
                  this.plan.customAge = []
                  if (typeof age === 'string') this.plan.age = [age]
                  else this.plan.age = age
                } else if (customAge && customAge !== '0') {
                  this.ageMode = 'CUSTOM'
                  this.plan.age = []
                  if (typeof customAge === 'string') this.plan.customAge = [customAge]
                  else {
                    this.$set(this.plan.customAge, 0, Number(customAge[0]))
                    this.$set(this.plan.customAge, 1, Number(customAge[1]))
                  }
                }
                if (typeof education === 'string' && education !== '0') this.plan.education = [education]
                else this.plan.education = education
                region = applyKey(region)
                newInterests = applyKey(newInterests)
                keywords = applyKey(keywords)
                directories = applyKey(directories)
                articleType = applyKey(articleType)
                mediaCategories = applyKey(mediaCategories)
                crowd = applyKey(crowd)
                excludeCrowd = applyKey(excludeCrowd)
                androidVersion = applyKey(androidVersion)
                iosVersion = applyKey(iosVersion)
                lifeStage = applyKey(lifeStage)

                // 省市绑定
                if (isArray(region)) {
                  this.allRegion = 'CUSTOM'
                  this.decompile(region, this.cityData)
                }
                // 人群包定向
                if (isArray(crowd)) {
                  this.audienceMode = 'AUDIENCE'
                  crowd.forEach((ret) => {
                    const item = getKeyOfData(this.audienceData, 'id', parseInt(ret))
                    this.$set(item, 'select', 'include')
                  })
                }
                // 人群包定向
                if (isArray(excludeCrowd)) {
                  this.audienceMode = 'AUDIENCE'
                  excludeCrowd.forEach((ret) => {
                    const item = getKeyOfData(this.audienceData, 'id', parseInt(ret))
                    this.$set(item, 'select', 'exclude')
                  })
                }
                // 意图词
                if (isArray(keywords) && keywords.length) {
                  this.keywordsType = 'ADD'
                  this.$set(this.plan, 'keywords', keywords)
                }
                // 定向媒体
                if (isArray(mediaCategories)) {
                  this.decompile(mediaCategories, this.mediagoryData)
                } else if (mediaCategories !== '0') {
                  this.decompile([mediaCategories], this.mediagoryData)
                }
                // 兴趣分类
                if (isArray(newInterests)) {
                  this.interestType = 'CUSTOM'
                  this.decompile(newInterests, this.interestData)
                }
                // 贴吧主题
                if (isArray(directories)) {
                  this.directoriesType = 'CUSTOM'
                  this.decompile(directories, this.themeData)
                }
                // 文章分类
                if (isArray(articleType)) {
                  this.article = 'CUSTOM'
                  this.decompile(articleType, this.articleData)
                }
                // 操作系统
                if (isArray(androidVersion)) {
                  this.plan.device = '2'
                  this.$set(this.plan, 'androidVersion', androidVersion)
                } else if (isArray(iosVersion)) {
                  this.plan.device = '1'
                  this.$set(this.plan, 'iosVersion', iosVersion)
                }
                // 人生阶段
                if (isArray(lifeStage)) {
                  this.$set(this.plan, 'lifeStage', lifeStage)
                }
                // APP定向
                app = app && JSON.parse(app)
                if (app) {
                  const { type, list, behavior } = app
                  this.appType = type
                  if (behavior.includes(4) && behavior.length === 1) this.appBehavior = 4
                  else this.appBehavior = 2
                  if (type === 'category') {
                    this.decompile(
                      list.map((ret) => ret.id),
                      this.gategoryData
                    )
                  } else if (type === 'custom') this.$set(this, 'mult_app', list)
                }
                // 定价延迟在计费方式后 联动问题
                timeout(0).then(() => {
                  // 重复更新转化列表
                  if (this.plan.transFrom !== 1) {
                    getConvert({ transFrom: this.plan.transFrom, ad_account_id: this.plan.ad_account_id }).then((data) => {
                      isArray(data) && (this.adconverts = data)
                    })
                  }
                })
              } else {
                throw new Error('获取推广单元详情接口错误：非数组或空数组返回')
              }
            }
            this.$Spin.hide() // 加载完成
          })
          .catch((e) => {
            this.$Spin.hide() // 加载完成
          })
      } else {
        this.$Message.error('当前创意ID或账号ID不存在!')
      }
    },
    // 还原选择
    decompile(Ids, data) {
      const deepSelect = (item) => {
        item.forEach((ret) => {
          if (ret && ret.children && ret.children.length) deepSelect(ret.children)
          !ret.disabled && this.$set(ret, 'check', true)
        })
      }
      if (isArray(Ids) && Ids.length) {
        Ids.forEach((ret) => {
          const item = getKeyOfData(data, 'id', Number(ret))
          deepSelect([item])
        })
      }
    },
    // 选择游戏
    handleGame(meta) {
      this.plan.game_id = meta.id
      this.plan.package = meta.ad_package // 更改成显示包名
      this.plan.game_address = meta.game_address
      if (this.isAndroid) {
        if (isArray(meta.sdks) && meta.sdks.includes('2008')) this.plan.callback_switch = 0
        else this.plan.callback_switch = 1
      }
    },
    // 选择代投账号
    handleAgent(meta) {
      this.plan.proxy_account_id = meta.id
    },
    // 代投账号
    changeAgent(val) {
      if (val === 'AGENT') this.plan.proxy_account_id = ''
      else this.plan.proxy_account_id = undefined
    },
    // 批量开关
    changeBatch(val) {
      if (val) {
        this.plan.bitch_add_begin = ''
        this.plan.bitch_add_end = ''
      } else {
        this.plan.bitch_add_begin = undefined
        this.plan.bitch_add_end = undefined
      }
    },
    changeFtypes(val) {
      if (val === 'NONE') this.plan.ftypes = 0
      else {
        this.plan.ftypes = []
        this.plan.leagueOpenFlag = 1
      }
    },
    changeBidtype(bid, media) {
      if (bid === 2) {
        this.minBudget = 2
        this.maxBudget = 9999.99
      } else if (media) {
        this.minBudget = 0.2
        this.maxBudget = 999.99
      } else {
        this.minBudget = 0.3
        this.maxBudget = 999.99
      }
    },
    changeSkip(val) {
      if (val) this.plan.bid = 0
      else this.plan.bid = ''
    },
    changePlatform(val) {
      if (!this.editState) {
        this.plan.game_id = ''
        this.plan.package = ''
      }
    },
    changeRetarget(val) {
      if (val === 'NONE') {
        this.audienceData.forEach((ret) => {
          this.$set(ret, 'select', '')
        })
      }
    },
    changeAge() {
      this.plan.age = [1]
      this.plan.customAge = []
    },
    appendMultword(vals) {
      this.plan.keywords.push(...vals)
    },
    deleteMultWord(val) {
      if (!val) return
      const idx = this.plan.keywords.indexOf(val)
      this.plan.keywords.splice(idx, 1)
    },
    changeKeyword(val) {
      let keywordsExtend, keywords
      if (val === 'ADD') {
        keywordsExtend = '1'
        keywords = []
      }
      this.$set(this.plan, 'keywordsExtend', keywordsExtend)
      this.$set(this.plan, 'keywords', keywords)
    },
    // 全选
    selectAll({ list, check = true, current = '' }) {
      let data
      // 无限递归
      const setAllChecked = (data, check) => {
        data.forEach((ret) => {
          if (ret.children && ret.children.length) setAllChecked(ret.children, check)
          this.$set(ret, 'check', check)
        })
      }
      if (current) {
        const item = getNameOfData(list, current)
        data = item.children
      } else data = list
      setAllChecked(data, check)
    },
    // 删除已选
    delTag({ list, name }) {
      const data = getNameOfData(list, name)
      if (data.children && data.children.length) {
        this.selectAll({ list, check: false, current: data.value })
      } else {
        this.$set(data, 'check', false)
      }
    },
    // 清空全部
    clearTag({ list }) {
      clearTagOfData(list, this)
    },
    delRetarget({ list, name }) {
      const index = list.findIndex((ret) => ret.name === name)
      if (index > -1) {
        this.$set(list[index], 'select', null)
      }
    },
    // 清空人群包
    clearRetarget({ list }) {
      list.forEach((item) => {
        this.$set(item, 'select', null)
      })
    },
    // 选择落地页回调
    selectLinkLandPage(meta) {
      this.plan.page_addr = meta.page_addr
      this.plan.land_page_id = meta.land_page_id
      this.linkModel = false
    },
    // 选择计划管家
    butlerSelect(meta) {
      this.managePlan = [meta]
      this.butlerModel = false
    },
    // 自动获焦
    focuslpUrl(val) {
      if (!val && this.$refs.lpurl) {
        timeout(300).then(() => {
          this.$refs.lpurl[0].focus()
        })
      }
    },
    loadConvert(val) {
      this.converting = val
    },
    getAdConverts() {
      this.converting = false
      getConvert({
        transFrom: this.plan.transFrom,
        ad_account_id: this.plan.ad_account_id
      }).then((data) => {
        this.converting = true
        if (data) {
          isArray(data) && (this.adconverts = data)
        }
      })
    },
    // 深度出价
    changDeepBid(val) {
      this.$set(this.plan, 'deep_bid_range', 0)
      this.$set(this.plan, 'deepOcpcBid', '')
      this.$set(this.plan, 'roiRatio', '')
      this.$set(this.plan, 'deep_mode_type', val ? 'optimizeDeepTrans' : '')
      this.$set(this.plan, 'deepTransType', 26)
    },
    preloadData() {
      const account = this.plan.ad_account_id
      // 查推广计划详细
      const param = {
        id: this.plan.campaignFeedId,
        ad_account_id: account
      }
      // 查意图标签过滤数据
      const param2 = {
        ad_account_id: account
      }

      // 查转化类型下的转化
      const param3 = {
        transFrom: this.plan.transFrom,
        ad_account_id: account
      }
      // 查人群包
      const param4 = { ad_account_id: account }

      // 请求开始
      this.$Spin.show()
      Promise.all([
        getCaoHuaGames(),
        getCaoHuaAgent(),
        getCampaign(param),
        getConvert(param3),
        // getTagFilterFeed(param2),
        getAudience(param4)
      ])
        .then((data) => {
          const [gameData, agentData, campaignData, convertData, audienceData] = data
          isArray(gameData) && (this.gameData = gameData)
          isArray(agentData) && (this.agentData = agentData)
          isArray(convertData) && (this.adconverts = convertData)
          // isArray(tagFilterData) && (this.tagFilterData = replaceConditions(tagFilterData))
          isArray(audienceData) &&
            (this.audienceData = audienceData
              .filter((ret) => ret.groupStatus === 'finished')
              .map((ret) => Object.assign(ret, { id: ret.groupId, name: ret.groupName, type: ret.groupTypeDesc })))
          if (isArray(campaignData) && campaignData.length) {
            const { campaignFeedName, subject, gameId } = campaignData.pop()
            this.plan.campaignFeedName = campaignFeedName
            this.plan.subject = subject
            if (gameId) {
              this.plan.game_id = gameId
              this.plan.package = this.gameData.filter((ret) => ret.id === gameId).pop().ad_package
            }
          }
          if (this.$router.currentRoute.query.ad) this.getData()
          else this.$Spin.hide()
        })
        .catch((e) => {
          throw new Error('请求接口错误')
        })
    },
    customValid() {
      const err = []
      // 流量
      if (this.ftypes !== 'NONE' && isArray(this.plan.ftypes) && !this.plan.ftypes.length) {
        err.push({ feild: '投放流量', msg: '投放流量不能为空' })
      }
      // app id 不能超过1000
      if (this.appType === 'custom' && this.plan.app.length > 1000) {
        err.push({ feild: 'APP定向', msg: 'APP定向名称不能超过1000个' })
      }
      console.log(this.plan.app)
      if (this.appType !== 'all' && !this.plan.app.length) {
        err.push({ feild: 'APP定向', msg: 'APP定向非不限时，必须选择定向数据' })
      }
      // 意图词
      if (
        this.keywordsType === 'ADD' &&
        this.plan.keywords &&
        this.plan.keywords.includes(',') &&
        this.plan.keywords.split(',').length > 1000
      ) {
        err.push({ feild: '商业意图', msg: '添加意图词不能超过1000个' })
      }
      if (this.keywordsType === 'ADD' && !this.plan.keywords) {
        err.push({ feild: '商业意图', msg: '添加意图词不能为空' })
      }
      return err
    },
    valid() {
      const rules = [
        {
          name: 'plan/plan_name',
          relyon: 'editState',
          relyvalue: false,
          require: true,
          min: 2,
          max: 90,
          desc: '计划名称'
        },
        {
          name: 'plan/game_id',
          require: true,
          min: 1,
          desc: '投放游戏'
        },
        {
          name: 'plan/proxy_account_id',
          require: true,
          relyon: 'plan/agent',
          relyvalue: 'AGENT',
          min: 1,
          desc: '代投账号'
        },
        {
          name: 'plan/land_page_id',
          require: true,
          relyon: 'plan/landing_type',
          relyvalue: 'LINK',
          min: 1,
          desc: '落地页地址'
        },
        {
          name: 'plan/package',
          require: true,
          min: 4,
          max: 100,
          desc: '游戏包名称'
        },
        {
          name: 'plan/bitch_add_begin',
          require: true,
          relyon: 'batch',
          relyvalue: true,
          min: 1,
          desc: '批量起始数'
        },
        {
          name: 'plan/bitch_add_end',
          require: true,
          relyon: 'batch',
          relyvalue: true,
          min: 1,
          desc: '批量结尾数'
        },
        {
          name: 'plan/lpUrl',
          require: true,
          relyon: 'plan/innerUrl',
          relyvalue: false,
          pattern: '^((https|http)?://)[^s]+',
          min: 1,
          max: 1024,
          desc: '推广URL'
        },
        {
          name: 'plan/ocpcBid',
          require: true,
          relyon: 'plan/bidtype',
          relyvalue: 3,
          min: 0.3,
          max: 99999.99,
          desc: '目标转化出价',
          msg: '0.3-999.99之间的数字，精确到小数点后2位'
        },
        {
          name: 'plan/deepOcpcBid',
          require: true,
          relyon: 'plan/deep_mode_type',
          relyvalue: 'optimizeDeepTrans',
          min: this.plan.ocpcBid || 0.4,
          max: 99999.99,
          desc: '深度转化出价',
          msg: '0.4-9999.99之间的数字，且取值需要大于目标转化出价，精确到小数点后2位'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    submit(next) {
      const loading = next ? 'loading' : 'saving'
      this.errRes = [...this.valid(), ...this.customValid()] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }
      const commonParams = this.pullKeys(
        [
          'ad_account_id',
          'ad_id',
          'campaign_ids',
          'plan_name',
          'ch_platform_id',
          'game_id',
          'proxy_account_id',
          'landing_type',
          'land_page_id',
          'monitor_template_id',
          'bitch_add_begin',
          'bitch_add_end',
          'union_flag'
        ],
        this.plan
      )
      const baiduParams = this.pullKeys(
        [
          'ftypes',
          'leagueOpenFlag',
          'producttypes',
          'bidtype',
          'ocpcBid',
          'transType',
          'transFrom',
          'lpUrl',
          'innerUrl',
          'appTransId',
          'deepTransType',
          'roiRatio',
          'deepOcpcBid',
          'deep_bid_mode',
          'deep_mode_type'
        ],
        this.plan
      )

      // 额外参数处理
      baiduParams.ftypes === 0 && (baiduParams.ftypes = [])
      baiduParams.producttypes === 0 && (baiduParams.producttypes = [])
      baiduParams[baiduParams.deep_mode_type] = baiduParams.deep_bid_mode
      baiduParams.audience = this.buildAudience()
      const params = { commonParams, baiduParams }

      this[loading] = true
      updateAdgroup(params).then((data) => {
        this[loading] = false

        if (data && data.ad_id && data.ch_plan_id) {
          const { ch_plan_id, ad_id } = data
          if (next) {
            let query = { plan: ch_plan_id }
            if (this.creativStat) query = Object.assign(query, { t: 'edit' })
            this.jumpToIdea(
              {
                id: this.plan.campaignFeedId,
                ad: ad_id
              },
              query
            )
          } else {
            this.cannel()
          }
        }
      })
    },
    submitToNext() {
      this.errRes = [...this.valid(), ...this.customValid(), ...this.betchValid(this.plan)] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }
      const commonParams = this.pullKeys(
        [
          'ad_account_id',
          'campaign_ids',
          'plan_name',
          'ch_platform_id',
          'game_id',
          'proxy_account_id',
          'landing_type',
          'land_page_id',
          'monitor_template_id',
          'bitch_add_begin',
          'bitch_add_end',
          'union_flag'
        ],
        this.plan
      )
      const baiduParams = this.pullKeys(
        [
          'ftypes',
          'leagueOpenFlag',
          'producttypes',
          'bidtype',
          'ocpcBid',
          'transType',
          'transFrom',
          'lpUrl',
          'innerUrl',
          'deepTransType',
          'roiRatio',
          'deepOcpcBid',
          'deep_bid_mode',
          'deep_mode_type'
        ],
        this.plan
      )

      // 额外参数处理
      baiduParams.ftypes === 0 && (baiduParams.ftypes = [])
      baiduParams.producttypes === 0 && (baiduParams.producttypes = [])
      baiduParams[baiduParams.deep_mode_type] = baiduParams.deep_bid_mode
      baiduParams.audience = this.buildAudience()
      const params = { commonParams, baiduParams }

      this.loading = true
      addAdgroup(params).then((data) => {
        if (data && data.plan_info) {
          const { success_cnt, req_id, plan_info } = data
          // ocpc 转化弹窗
          if (baiduParams.bidtype === 3) {
            this.loading = false
            this.convertData = Object.assign({}, plan_info, { success_cnt, req_id })
            this.convertModel = true
            this.converting = true
          } else {
            this.skipConvert(req_id)
          }
        } else this.loading = false
      })
    },
    buildAudience() {
      let audience = this.pullKeys(
        [
          'age',
          'customAge',
          'sex',
          'education',
          'region',
          'newInterests',
          'directories',
          'articleType',
          'device',
          'net',
          'excludeCrowd',
          'crowd',
          'lifeStage',
          'autoExpansion',
          'excludeTrans'
        ],
        this.plan
      )

      // 百度联盟媒体
      if (this.bindMediaType) {
        const { mediaCategoriesBindType, mediaCategories } = this.pullKeys(['mediaCategoriesBindType', 'mediaCategories'], this.plan)
        audience = Object.assign(audience, { mediaCategoriesBindType, mediaCategories: mediaCategories === '0' ? '' : mediaCategories })
      }

      // 意图词
      if (this.keywordsType === 'ADD') {
        const { keywords, keywordsExtend } = this.pullKeys(['keywords', 'keywordsExtend'], this.plan)
        const words = keywords.join(',')
        audience = Object.assign(audience, { keywords: words, keywordsExtend })
      }

      // 学历
      const { age, customAge, education, device } = audience
      const { androidVersion, iosVersion, lifeStage } = this.plan
      if (isArray(age)) audience = Object.assign(audience, { age: age.join(',') })
      if (isArray(customAge)) audience = Object.assign(audience, { customAge: customAge.join(',') })
      if (isArray(education)) audience = Object.assign(audience, { education: education.join(',') })

      // 操作系统
      if (device === '2') {
        if (isArray(androidVersion)) audience.androidVersion = androidVersion.join(',')
        else audience.androidVersion = androidVersion
      } else if (device === '1') {
        if (isArray(iosVersion)) audience.iosVersion = iosVersion.join(',')
        else audience.iosVersion = iosVersion
      }

      // 人生阶段
      if (isArray(lifeStage)) {
        audience.lifeStage = lifeStage.join(',')
      } else audience.lifeStage = lifeStage

      // app定向
      const app = { type: this.appType, list: this.plan.app, behavior: isArray(this.appBehavior) ? this.appBehavior : [this.appBehavior] }
      audience = Object.assign(audience, { app: JSON.stringify(app) })

      // 人群包最大
      const { crowd, excludeCrowd } = audience
      if (isArray(crowd) || isArray(excludeCrowd)) {
        isArray(crowd) &&
          (audience = Object.assign(audience, {
            crowd: crowd.join(','),
            directories: '0',
            mediaCategoriesBindType: '0',
            mediaCategories: ''
          }))
        isArray(excludeCrowd) &&
          (audience = Object.assign(audience, {
            excludeCrowd: excludeCrowd.join(','),
            directories: '0',
            mediaCategoriesBindType: '0',
            mediaCategories: ''
          }))
      }
      if (this.editState) {
        // 编辑要设置空值
        !isArray(crowd) && (audience = Object.assign(audience, { crowd }))
        !isArray(excludeCrowd) && (audience = Object.assign(audience, { excludeCrowd }))
      } else {
        !isArray(crowd) && (audience = Object.assign(audience, { crowd: undefined }))
        !isArray(excludeCrowd) && (audience = Object.assign(audience, { excludeCrowd: undefined }))
      }
      return audience
    },
    skipConvert(req_id) {
      const param = {
        ad_account_id: this.plan.ad_account_id,
        req_id
      }
      creatAdgroup(param).then((data) => {
        this.loading = false
        if (data && isArray(data)) {
          this.data = data
          this.model = true
        }
      })
    },
    jump() {
      if (isArray(this.data) && this.data.length) {
        const ids = this.data.filter((ret) => ret.ad_id)
        if (ids.length) {
          const { ad_id, req_id, plan_id } = ids[0]
          this.jumpToIdea(
            {
              id: this.plan.campaignFeedId,
              ad: ad_id
            },
            {
              req: req_id,
              plan: plan_id
            }
          )
        } else {
          this.$Message.error({
            closable: true,
            duration: 5,
            content: '创建推广单元全部失败，不能创建创意'
          })
        }
      }
    }
  },
  data() {
    return {
      loading: null,
      saving: null,
      formErr: null, // 表单检验状态
      errRes: [], // 错误的数值

      gameData: [], // 常用游戏下拉数据
      agentData: [], // 代投账号下拉数据
      cityData: cityData, // 地域JSON数据
      interestData: newInterestData, // 兴趣分类数据
      audienceData: [], // 覆盖人群包数据
      gategoryData: gategoryData, // app定向分类数据
      articleData: articleData, // 文章分类数据
      themeData: themeData, // 贴吧主题数据
      mediagoryData: mediagoryData, // 定向媒体分类数据
      android_version: android_version,
      ios_version: ios_version,
      plan: {
        ad_account_id: 0,
        subject: 1, // 推广对象
        campaign_ids: [], // 批量广告组
        campaignFeedId: this.$router.currentRoute.params.id, // 广告组ID
        campaignFeedName: '',
        ad_id: this.$router.currentRoute.query.ad, // 计划ID
        plan_name: '', // 广告计划名称
        ch_platform_id: 1, // 游戏类型
        agent: 'NOAGENT', // 是否代投
        game_id: '',
        proxy_account_id: undefined,
        landing_type: 'LINK', // 投放方式
        package: '', // 游戏包名
        page_addr: '', // 落地页
        callback_switch: 0,
        callback_settings: ['callbackTypeActive', 'callbackTypeRegist', 'callbackTypeRecharge', 'callbackTypeMoney'],
        // union_flag: false, // 联盟流量监测链接
        land_page_id: undefined, // 落地页ID
        bitch_add_begin: undefined, // 批量起始
        bitch_add_end: undefined,

        ftypes: 0, // 投放流量
        producttypes: 0, // 投放版位
        leagueOpenFlag: 1, // 包含位置
        mediaCategoriesBindType: '0', // 定向媒体
        mediaCategories: '0', // 媒体集

        region: '9999999', // 地域集合
        sex: '0', // 性别
        age: '', // 年龄
        customAge: [18, 55],
        education: '0', // 学历
        interests: '0', // 长期兴趣
        keywordsExtend: '1', // 意图词用户行为
        newInterests: '0',
        directories: '0', // 贴吧主题
        articleType: '0', // 文章分类
        app: [],
        device: '2', // 平台
        androidVersion: '0',
        iosVersion: '0',
        net: '0', // 网络
        lifeStage: '0',
        autoExpansion: '0',
        excludeTrans: '0',

        bidtype: 3, // 投放目标
        transType: 4, // 转化类型
        transFrom: 1,
        innerUrl: true, // 系统推荐落地页
        lpUrl: '', // 推广URL
        ocpcLevel: 2, // oCPC投放阶段
        ocpcBid: '', // 第二阶段出价
        deep_bid_mode: false, // 深度转化出价
        deep_mode_type: '', // 深度优化方式
        roiRatio: '', // ROI系数
        deepTransType: '', // 深度转化目标
        deepOcpcBid: '' // 输入深度价格
      },

      batch: null, // 是否批量建立
      managePlan: [], // 计划管家

      ageMode: 'NONE',
      interestType: 'NONE',
      keywordsType: 'NONE', // 意图词
      ftypes: 'NONE', // 流量类型
      allRegion: 'NONE', // 地域
      audienceMode: 'NONE', // 自定义人群包
      directoriesType: 'NONE', // 贴巴主题
      article: 'NONE', // 文章分类
      appType: 'all', // app定向
      appBehavior: 2, // 用户app行为
      industry: [], // 意图标签选择
      res_word: [], // 意图词接口获取

      minBudget: 0.3, // 最小定价
      maxBudget: 999.99, // 最大定价
      ad: 'oCPC',
      hideSkipStage: null, // 显示跳过第一阶段

      adconverts: [], // 转化名称列表
      converting: null, // 加载状态
      creativStat: null, // 是否有创意
      convertData: {}, // 转化前数据

      // model
      linkModel: null, // 落地页弹出框
      butlerModel: null, // 计划弹出框
      convertModel: null, // 转化弹出框
      model: null, // 批量结果对话框显示状态
      columns: [
        {
          key: 'campaign_name',
          title: '推广计划'
        },
        {
          key: 'plan_name',
          title: '推广单元'
        },
        {
          key: 'inner_status',
          title: '内部计划'
        },
        {
          key: 'outer_status',
          title: '结果',
          render: (h, params) => {
            const { ad_id, outer_status, remark } = params.row
            const msg = ad_id ? outer_status : `${outer_status}, ${remark}`
            return h('span', msg)
          }
        }
      ], // 结果表格
      data: [] // 批量结果
    }
  },
  created() {
    const campaigns = window.sessionStorage.getItem('campaigns')
    const account = getSession('qianduan_media_account_id')
    if (this.$router.currentRoute.query.t !== 'edit') this.beforeHandler()

    // 批量广告组ids
    this.plan.campaign_ids = campaigns ? [...JSON.parse(campaigns)] : [this.plan.campaignFeedId]
    this.plan.ad_account_id = account
    this.$store.commit('Baidu/clearModulerLinks')
    this.preloadData()
  }
}
